// Expanded mock data for social + directory platform
export const currentUser = {
  slug: "tu",
  handle: "tu_arte",
  name: "Tú",
  role: "Artista visual",
  city: "Madrid",
  avatar:
    "https://images.unsplash.com/photo-1741746333312-e705a8cb506b?w=400&q=80",
  followers: 128,
  following: 340,
  posts: 12,
};

export const disciplines = [
  { slug: "artes-visuales", name: "ARTES VISUALES", tag: "#visual", count: 428 },
  { slug: "musica", name: "MÚSICA", tag: "#musica", count: 567 },
  { slug: "artes-escenicas", name: "ESCÉNICAS", tag: "#escenica", count: 312 },
  { slug: "arte-digital", name: "ARTE DIGITAL", tag: "#digital", count: 241 },
  { slug: "literatura", name: "LITERARIAS", tag: "#literatura", count: 184 },
  { slug: "aplicadas", name: "APLICADAS", tag: "#aplicadas", count: 198 },
];

export const profileTypes = [
  {
    no: "01",
    slug: "visual-artist",
    title: "ARTISTA VISUAL",
    desc: "Pintura, escultura, fotografía, grabado, ilustración, textil, cerámica.",
  },
  {
    no: "02",
    slug: "musician",
    title: "MÚSICX · SONIDO",
    desc: "Composición, producción, performance, sonido experimental, dj.",
  },
  {
    no: "03",
    slug: "hybrid",
    title: "HÍBRIDX · MULTIDISCIPLINAR",
    desc: "Trabajo en varias disciplinas: performance, video, digital, escénicas.",
  },
  {
    no: "04",
    slug: "collective",
    title: "COLECTIVO · SELLO",
    desc: "Grupo, colectivo, label, espacio, gestorx cultural o curadorx.",
  },
];

export const artists = [
  {
    slug: "mar-quintero",
    handle: "mar_quintero",
    name: "Mar Quintero",
    role: "Pintora contemporánea",
    city: "Madrid · ES",
    discipline: "ARTES VISUALES",
    avatar:
      "https://images.unsplash.com/photo-1776235522022-68ff83b0b9e0?w=600&q=80",
    cover:
      "https://images.unsplash.com/photo-1764345933694-7d4eb49ef266?w=1600&q=80",
    bio: "Pintura abstracta como lenguaje de la memoria. Actualmente residiendo en Matadero Madrid.",
    followers: 12400,
    following: 280,
    posts: 84,
    verified: true,
  },
  {
    slug: "kenji-rios",
    handle: "kenji_rios",
    name: "Kenji Ríos",
    role: "Artista digital · Generativo",
    city: "CDMX · MX",
    discipline: "ARTE DIGITAL",
    avatar:
      "https://images.unsplash.com/photo-1751228917571-23c187b23753?w=600&q=80",
    cover:
      "https://images.unsplash.com/photo-1761078739072-a10f63f3e478?w=1600&q=80",
    bio: "Código, color, caos controlado. p5.js · Processing · TouchDesigner.",
    followers: 23890,
    following: 140,
    posts: 312,
    verified: true,
  },
  {
    slug: "lola-serrano",
    handle: "lola_serrano",
    name: "Lola Serrano",
    role: "Cantante · Compositora",
    city: "Barcelona · ES",
    discipline: "MÚSICA",
    avatar:
      "https://images.unsplash.com/photo-1769998835730-c22ade729d63?w=600&q=80",
    cover:
      "https://images.pexels.com/photos/13230484/pexels-photo-13230484.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bio: "Entre el bolero y la electrónica. Nuevo EP en marzo.",
    followers: 45200,
    following: 312,
    posts: 128,
    verified: true,
  },
  {
    slug: "alain-mora",
    handle: "alain_mora",
    name: "Alain Mora",
    role: "Bailarín contemporáneo",
    city: "Buenos Aires · AR",
    discipline: "ESCÉNICAS",
    avatar:
      "https://images.unsplash.com/photo-1765278613909-e8307bf72b20?w=600&q=80",
    cover:
      "https://images.pexels.com/photos/24408960/pexels-photo-24408960.jpeg",
    bio: "El cuerpo como archivo vivo.",
    followers: 8920,
    following: 180,
    posts: 56,
    verified: false,
  },
  {
    slug: "yuki-nakamura",
    handle: "yuki_naka",
    name: "Yuki Nakamura",
    role: "Fotógrafa",
    city: "Kioto · JP",
    discipline: "ARTES VISUALES",
    avatar:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=600&q=80",
    cover:
      "https://images.unsplash.com/photo-1504198266287-1659872e6590?w=1600&q=80",
    bio: "Luz entre márgenes. 35mm · Leica M6.",
    followers: 18200,
    following: 420,
    posts: 240,
    verified: true,
  },
  {
    slug: "theo-volkov",
    handle: "theo_vk",
    name: "Theo Volkov",
    role: "Escultor multimedia",
    city: "Berlín · DE",
    discipline: "APLICADAS",
    avatar:
      "https://images.unsplash.com/photo-1527633412983-d80af308e660?w=600&q=80",
    cover:
      "https://images.unsplash.com/photo-1528895709218-bed5456e2c42?w=1600&q=80",
    bio: "Materia, peso y silencio.",
    followers: 3120,
    following: 98,
    posts: 34,
    verified: false,
  },
  {
    slug: "ines-valverde",
    handle: "inesv",
    name: "Inés Valverde",
    role: "Creadora digital",
    city: "Lisboa · PT",
    discipline: "ARTE DIGITAL",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&q=80",
    cover:
      "https://images.pexels.com/photos/3977944/pexels-photo-3977944.jpeg",
    bio: "Paisajes calculados con ternura. ✦",
    followers: 9830,
    following: 210,
    posts: 156,
    verified: true,
  },
  {
    slug: "tomas-herrera",
    handle: "tomash",
    name: "Tomás Herrera",
    role: "Poeta & dramaturgo",
    city: "Bogotá · CO",
    discipline: "LITERARIAS",
    avatar:
      "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=600&q=80",
    cover:
      "https://images.unsplash.com/photo-1512820790803-83ca734da794?w=1600&q=80",
    bio: "Escribir para no olvidar.",
    followers: 2140,
    following: 520,
    posts: 78,
    verified: false,
  },
  {
    slug: "sol-cabrera",
    handle: "sol_cabrera",
    name: "Sol Cabrera",
    role: "Ceramista",
    city: "Oaxaca · MX",
    discipline: "APLICADAS",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&q=80",
    cover:
      "https://images.unsplash.com/photo-1528895709218-bed5456e2c42?w=1600&q=80",
    bio: "Barro negro contemporáneo · Taller comunitario.",
    followers: 4820,
    following: 280,
    posts: 92,
    verified: false,
  },
  {
    slug: "andres-pinto",
    handle: "andres_vc",
    name: "Andrés Pinto",
    role: "Violonchelista",
    city: "Santiago · CL",
    discipline: "MÚSICA",
    avatar:
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=600&q=80",
    cover:
      "https://images.unsplash.com/photo-1465821185615-20b3c2fbf41b?w=1600&q=80",
    bio: "Bach y más allá. Disponible para sesiones.",
    followers: 1640,
    following: 90,
    posts: 23,
    verified: false,
  },
];

function findArtist(slug) {
  return artists.find((a) => a.slug === slug);
}

export const stories = [
  {
    id: "s1",
    artist: findArtist("mar-quintero"),
    cover:
      "https://images.unsplash.com/photo-1764345933694-7d4eb49ef266?w=800&q=80",
    label: "Estudio 02:34",
    live: false,
  },
  {
    id: "s2",
    artist: findArtist("lola-serrano"),
    cover:
      "https://images.unsplash.com/photo-1765278797923-10a027f5c69d?w=800&q=80",
    label: "Live · Razzmatazz",
    live: true,
  },
  {
    id: "s3",
    artist: findArtist("kenji-rios"),
    cover:
      "https://images.unsplash.com/photo-1761078739072-a10f63f3e478?w=800&q=80",
    label: "Process 48",
    live: false,
  },
  {
    id: "s4",
    artist: findArtist("alain-mora"),
    cover:
      "https://images.pexels.com/photos/24408960/pexels-photo-24408960.jpeg",
    label: "Ensayo general",
    live: false,
  },
  {
    id: "s5",
    artist: findArtist("yuki-nakamura"),
    cover:
      "https://images.unsplash.com/photo-1504198266287-1659872e6590?w=800&q=80",
    label: "Kioto 35mm",
    live: false,
  },
  {
    id: "s6",
    artist: findArtist("ines-valverde"),
    cover:
      "https://images.pexels.com/photos/3977944/pexels-photo-3977944.jpeg",
    label: "WIP ◦ render",
    live: false,
  },
  {
    id: "s7",
    artist: findArtist("theo-volkov"),
    cover:
      "https://images.unsplash.com/photo-1528895709218-bed5456e2c42?w=800&q=80",
    label: "Fragua",
    live: false,
  },
];

export const posts = [
  {
    id: "p1",
    artist: findArtist("mar-quintero"),
    time: "hace 2h",
    type: "image",
    image:
      "https://images.unsplash.com/photo-1764345933694-7d4eb49ef266?w=1400&q=80",
    aspect: "aspect-[4/5]",
    caption:
      "Serie 'Respirar el ocre' — pieza 04/12. Óleo sobre lino, 180×140. Próxima exposición en Galería Helga de Alvear.",
    tags: ["#pintura", "#abstracto", "#madrid"],
    likes: 2812,
    comments: 142,
    shares: 38,
    liked: false,
  },
  {
    id: "p2",
    artist: findArtist("lola-serrano"),
    time: "hace 4h",
    type: "live",
    image:
      "https://images.unsplash.com/photo-1765278797923-10a027f5c69d?w=1400&q=80",
    aspect: "aspect-video",
    caption:
      "EN VIVO ahora · Razzmatazz BCN · Nuevo tema estreno mundial 🔥 conéctense.",
    tags: ["#enviivo", "#música", "#barcelona"],
    likes: 8420,
    comments: 521,
    shares: 204,
    liked: true,
    live: true,
  },
  {
    id: "p3",
    artist: findArtist("kenji-rios"),
    time: "hace 7h",
    type: "image",
    image:
      "https://images.unsplash.com/photo-1761078739072-a10f63f3e478?w=1400&q=80",
    aspect: "aspect-square",
    caption:
      "Experimento generativo / p5.js / 2048 iteraciones. El código en bio.",
    tags: ["#generativo", "#p5js", "#codeart"],
    likes: 4120,
    comments: 89,
    shares: 312,
    liked: false,
  },
  {
    id: "p4",
    artist: findArtist("alain-mora"),
    time: "hace 11h",
    type: "video",
    image:
      "https://images.pexels.com/photos/24408960/pexels-photo-24408960.jpeg",
    aspect: "aspect-[3/4]",
    caption:
      "Fragmento de 'Cuerpo archivo'. Estreno el 14 en Teatro San Martín.",
    tags: ["#danza", "#performance", "#buenosaires"],
    likes: 1920,
    comments: 64,
    shares: 22,
    liked: false,
  },
  {
    id: "p5",
    artist: findArtist("yuki-nakamura"),
    time: "hace 1d",
    type: "image",
    image:
      "https://images.unsplash.com/photo-1504198266287-1659872e6590?w=1400&q=80",
    aspect: "aspect-[4/3]",
    caption: "Kioto, 6:42am. Nada más. Nada menos.",
    tags: ["#fotografía", "#35mm", "#japón"],
    likes: 6230,
    comments: 118,
    shares: 76,
    liked: true,
  },
  {
    id: "p6",
    artist: findArtist("ines-valverde"),
    time: "hace 1d",
    type: "image",
    image:
      "https://images.pexels.com/photos/3977944/pexels-photo-3977944.jpeg",
    aspect: "aspect-[4/5]",
    caption: "Estudios cromáticos para la nueva colección NFT 'Terra Sintética'.",
    tags: ["#artedigital", "#nft", "#color"],
    likes: 3240,
    comments: 47,
    shares: 58,
    liked: false,
  },
  {
    id: "p7",
    artist: findArtist("tomas-herrera"),
    time: "hace 2d",
    type: "text",
    caption:
      "«Escribo para no olvidar que alguna vez fui también el niño que miraba el techo y pensaba que el tiempo era una máquina de vapor.» — de mi nuevo poemario (inédito).",
    tags: ["#poesía", "#literatura"],
    likes: 980,
    comments: 52,
    shares: 14,
    liked: false,
  },
];

export const commentsByPost = {
  p1: [
    {
      id: "c1",
      artist: findArtist("kenji-rios"),
      text: "Esos ocres son otra cosa Mar. 🔥",
      time: "1h",
      likes: 24,
    },
    {
      id: "c2",
      artist: findArtist("yuki-nakamura"),
      text: "La textura del lino se siente hasta desde la pantalla.",
      time: "54m",
      likes: 12,
    },
    {
      id: "c3",
      artist: findArtist("theo-volkov"),
      text: "Nos vemos en el opening.",
      time: "32m",
      likes: 4,
    },
  ],
};

export const conversations = [
  {
    id: "conv1",
    artist: findArtist("kenji-rios"),
    last: "¿Colaboramos en un audiovisual?",
    time: "ahora",
    unread: 2,
  },
  {
    id: "conv2",
    artist: findArtist("lola-serrano"),
    last: "Te mando el demo hoy.",
    time: "10m",
    unread: 1,
  },
  {
    id: "conv3",
    artist: findArtist("yuki-nakamura"),
    last: "Gracias por el feedback ✨",
    time: "2h",
    unread: 0,
  },
  {
    id: "conv4",
    artist: findArtist("alain-mora"),
    last: "Perfecto, confirmo hora.",
    time: "1d",
    unread: 0,
  },
  {
    id: "conv5",
    artist: findArtist("ines-valverde"),
    last: "Mandé el pdf al jurado.",
    time: "3d",
    unread: 0,
  },
];

export const messages = {
  conv1: [
    { me: false, text: "Hola Mar, vi tus últimas piezas. Brutales.", time: "10:02" },
    { me: true, text: "Gracias!! Vi tu obra generativa, estoy obsesionada.", time: "10:04" },
    { me: false, text: "¿Colaboramos en un audiovisual?", time: "10:05" },
    { me: false, text: "Podría responder tu paleta con movimiento.", time: "10:05" },
  ],
};

export const notifications = [
  {
    id: "n1",
    type: "like",
    artist: findArtist("kenji-rios"),
    text: "le dio me gusta a tu publicación",
    time: "2m",
    target: "Serie Respirar el ocre",
  },
  {
    id: "n2",
    type: "follow",
    artist: findArtist("lola-serrano"),
    text: "comenzó a seguirte",
    time: "14m",
  },
  {
    id: "n3",
    type: "comment",
    artist: findArtist("yuki-nakamura"),
    text: "comentó en tu foto",
    time: "1h",
    target: "«La textura del lino…»",
  },
  {
    id: "n4",
    type: "mention",
    artist: findArtist("ines-valverde"),
    text: "te mencionó en una publicación",
    time: "3h",
  },
  {
    id: "n5",
    type: "like",
    artist: findArtist("theo-volkov"),
    text: "le dio me gusta a tu historia",
    time: "5h",
  },
  {
    id: "n6",
    type: "follow",
    artist: findArtist("alain-mora"),
    text: "comenzó a seguirte",
    time: "1d",
  },
  {
    id: "n7",
    type: "event",
    artist: findArtist("lola-serrano"),
    text: "transmitirá en vivo en 30 minutos",
    time: "1d",
  },
  {
    id: "n8",
    type: "comment",
    artist: findArtist("tomas-herrera"),
    text: "comentó: «brutal, mar.»",
    time: "2d",
  },
];

export const trendingTags = [
  { tag: "#matadero2026", posts: "2.4k" },
  { tag: "#artegenerativo", posts: "12k" },
  { tag: "#cerámicaviva", posts: "4.1k" },
  { tag: "#danzaexpandida", posts: "890" },
  { tag: "#analógico35mm", posts: "18k" },
  { tag: "#poesíasonora", posts: "620" },
];

export const suggestedArtists = [
  findArtist("theo-volkov"),
  findArtist("sol-cabrera"),
  findArtist("andres-pinto"),
];

export const liveShows = [
  {
    id: "live1",
    artist: findArtist("lola-serrano"),
    title: "Estreno mundial · nuevo EP",
    venue: "Razzmatazz BCN",
    status: "live",
    viewers: 2841,
    started: "hace 14m",
    cover:
      "https://images.unsplash.com/photo-1765278797923-10a027f5c69d?w=1600&q=80",
    discipline: "MÚSICA",
  },
  {
    id: "live2",
    artist: findArtist("kenji-rios"),
    title: "Pintando código · p5.js en vivo",
    venue: "Desde el estudio · CDMX",
    status: "live",
    viewers: 412,
    started: "hace 3m",
    cover:
      "https://images.unsplash.com/photo-1761078739072-a10f63f3e478?w=1600&q=80",
    discipline: "ARTE DIGITAL",
  },
  {
    id: "live3",
    artist: findArtist("mar-quintero"),
    title: "Sesión de estudio · Serie ocre",
    venue: "Matadero Madrid",
    status: "live",
    viewers: 184,
    started: "hace 48m",
    cover:
      "https://images.unsplash.com/photo-1764345933694-7d4eb49ef266?w=1600&q=80",
    discipline: "ARTES VISUALES",
  },
  {
    id: "sched1",
    artist: findArtist("alain-mora"),
    title: "Ensayo abierto · Cuerpo archivo",
    venue: "Teatro San Martín · AR",
    status: "scheduled",
    when: "Hoy · 21:30",
    cover:
      "https://images.pexels.com/photos/24408960/pexels-photo-24408960.jpeg",
    discipline: "ESCÉNICAS",
  },
  {
    id: "sched2",
    artist: findArtist("andres-pinto"),
    title: "Bach al atardecer · sesión acústica",
    venue: "Parque Forestal · Santiago",
    status: "scheduled",
    when: "Mañana · 18:00",
    cover:
      "https://images.unsplash.com/photo-1465821185615-20b3c2fbf41b?w=1600&q=80",
    discipline: "MÚSICA",
  },
  {
    id: "sched3",
    artist: findArtist("tomas-herrera"),
    title: "Lectura pública · poemario inédito",
    venue: "Librería Tornamesa · Bogotá",
    status: "scheduled",
    when: "Vie · 19:00",
    cover:
      "https://images.unsplash.com/photo-1512820790803-83ca734da794?w=1600&q=80",
    discipline: "LITERARIAS",
  },
  {
    id: "sched4",
    artist: findArtist("ines-valverde"),
    title: "Workshop · arte generativo",
    venue: "Streaming · online",
    status: "scheduled",
    when: "Sáb · 11:00",
    cover:
      "https://images.pexels.com/photos/3977944/pexels-photo-3977944.jpeg",
    discipline: "ARTE DIGITAL",
  },
];

export const liveChatByShow = {
  live1: [
    { id: "m1", artist: findArtist("kenji-rios"), text: "brutal la intro!!!", time: "22:14" },
    { id: "m2", artist: findArtist("mar-quintero"), text: "voz impecable 🔥", time: "22:15" },
    { id: "m3", artist: findArtist("yuki-nakamura"), text: "desde kioto escuchando ❤", time: "22:15" },
    { id: "m4", artist: findArtist("alain-mora"), text: "gira por latam cuándo?", time: "22:16" },
    { id: "m5", artist: findArtist("theo-volkov"), text: "la producción suena gigante", time: "22:17" },
    { id: "m6", artist: findArtist("ines-valverde"), text: "el segundo tema me partió", time: "22:18" },
    { id: "m7", artist: findArtist("tomas-herrera"), text: "poesía pura esto", time: "22:18" },
    { id: "m8", artist: findArtist("sol-cabrera"), text: "compra de entradas?", time: "22:19" },
    { id: "m9", artist: findArtist("andres-pinto"), text: "quiero colaborar en un arreglo", time: "22:19" },
  ],
};

// Permanent 24/7 rooms ("Salas")
export const rooms = [
  {
    slug: "estudio-abierto",
    name: "Estudio abierto · Pintura",
    category: "ARTES VISUALES",
    mood: "silencio productivo",
    activity: "Pintando · 7h 24min",
    participants: 12,
    capacity: 30,
    members: ["mar-quintero", "yuki-nakamura", "theo-volkov", "sol-cabrera"],
    ambient:
      "https://images.unsplash.com/photo-1764345933694-7d4eb49ef266?w=1600&q=80",
    description:
      "Pinta mientras otros pintan. Cámara opcional, mic muteado por defecto. Música ambiente.",
    color: "#FF3E00",
  },
  {
    slug: "jam-improvisada",
    name: "Jam improvisada",
    category: "MÚSICA",
    mood: "grooves abiertos",
    activity: "Jam en Cm · 2h 12min",
    participants: 8,
    capacity: 12,
    members: ["lola-serrano", "andres-pinto", "kenji-rios"],
    ambient:
      "https://images.unsplash.com/photo-1465821185615-20b3c2fbf41b?w=1600&q=80",
    description:
      "Entra con tu instrumento. Tempo y tonalidad acordados al aire. Host rota cada 20 min.",
    color: "#00FF66",
  },
  {
    slug: "silencio-compartido",
    name: "Silencio compartido · Escritura",
    category: "LITERARIAS",
    mood: "focus profundo",
    activity: "Pomodoro 23/25 min",
    participants: 19,
    capacity: 40,
    members: ["tomas-herrera", "ines-valverde", "mar-quintero"],
    ambient:
      "https://images.unsplash.com/photo-1512820790803-83ca734da794?w=1600&q=80",
    description:
      "Escribe en silencio con otros. Sin chat durante pomodoros. Descansos de 5 min abiertos.",
    color: "#0033FF",
  },
  {
    slug: "noche-sketching",
    name: "Noche de sketching",
    category: "ARTES VISUALES",
    mood: "dibujo libre",
    activity: "Ronda de 10 min · 4/8",
    participants: 6,
    capacity: 15,
    members: ["yuki-nakamura", "alain-mora"],
    ambient:
      "https://images.unsplash.com/photo-1528895709218-bed5456e2c42?w=1600&q=80",
    description:
      "Sketch en rondas cortas con referencia compartida. Bot selecciona referencia cada 10 min.",
    color: "#FF3E00",
  },
  {
    slug: "ambient-electronico",
    name: "Ambient electrónico · 24/7",
    category: "ARTE DIGITAL",
    mood: "drone + visuals",
    activity: "DJ rotativo · ahora Ines V.",
    participants: 47,
    capacity: 100,
    members: ["ines-valverde", "kenji-rios", "andres-pinto", "theo-volkov"],
    ambient:
      "https://images.unsplash.com/photo-1761078739072-a10f63f3e478?w=1600&q=80",
    description:
      "Canal de ambient 24/7 curado por la comunidad. Escucha mientras trabajas.",
    color: "#FF3E00",
  },
  {
    slug: "sala-de-critica",
    name: "Sala de crítica",
    category: "MIXTO",
    mood: "feedback constructivo",
    activity: "Crítica cerrada · 3/5",
    participants: 5,
    capacity: 8,
    members: ["theo-volkov", "mar-quintero", "sol-cabrera"],
    ambient:
      "https://images.unsplash.com/photo-1528895709218-bed5456e2c42?w=1600&q=80",
    description:
      "Presenta tu obra en curso, recibe feedback de colegas. Cupo limitado, turnos de 15 min.",
    color: "#FF0033",
  },
  {
    slug: "dance-warmup",
    name: "Dance warmup",
    category: "ESCÉNICAS",
    mood: "cuerpo despierto",
    activity: "Warmup guiado · 18 min",
    participants: 14,
    capacity: 25,
    members: ["alain-mora", "lola-serrano"],
    ambient:
      "https://images.pexels.com/photos/24408960/pexels-photo-24408960.jpeg",
    description:
      "Calentamiento diario 9am y 7pm. Cualquier disciplina. Música por el host.",
    color: "#00FF66",
  },
  {
    slug: "reading-room",
    name: "Reading room",
    category: "LITERARIAS",
    mood: "lectura async",
    activity: "Leyendo · Pizarnik",
    participants: 23,
    capacity: 50,
    members: ["tomas-herrera", "mar-quintero", "yuki-nakamura"],
    ambient:
      "https://images.unsplash.com/photo-1512820790803-83ca734da794?w=1600&q=80",
    description:
      "Leer juntos en silencio. Cada mes un libro propuesto. Comentarios tipo subrayado compartido.",
    color: "#0033FF",
  },
];

export function getRoom(slug) {
  return rooms.find((r) => r.slug === slug) || rooms[0];
}

export function getRoomMembers(room) {
  return (room.members || [])
    .map((slug) => findArtist(slug))
    .filter(Boolean);
}

// MONETIZATION
export const products = [
  {
    id: "pr1",
    artist: findArtist("mar-quintero"),
    title: "Respirar el ocre · 04",
    type: "original",
    price: 4200,
    currency: "EUR",
    image: "https://images.unsplash.com/photo-1764345933694-7d4eb49ef266?w=1200&q=80",
    available: true,
    description: "Óleo sobre lino · 180×140 cm · firmado al dorso",
    edition: "1 / 1 · Obra única",
    shipping: "Internacional · 3-10 días",
    sold: 0,
  },
  {
    id: "pr2",
    artist: findArtist("mar-quintero"),
    title: "Respirar el ocre · Print A3",
    type: "print",
    price: 65,
    currency: "EUR",
    image: "https://images.unsplash.com/photo-1764345933694-7d4eb49ef266?w=1200&q=80",
    available: true,
    description: "Impresión Giclée en papel Hahnemühle 310gsm",
    edition: "Edición de 50 · #12 disponible",
    shipping: "Gratis en ES, €12 internacional",
    sold: 38,
  },
  {
    id: "pr3",
    artist: findArtist("kenji-rios"),
    title: "Generative · Fase 2048",
    type: "nft",
    price: 0.8,
    currency: "ETH",
    image: "https://images.unsplash.com/photo-1761078739072-a10f63f3e478?w=1200&q=80",
    available: true,
    description: "Arte generativo p5.js · token on Base · animado 4K",
    edition: "Edición abierta · Blockchain verified",
    sold: 142,
  },
  {
    id: "pr4",
    artist: findArtist("kenji-rios"),
    title: "Commission · Identidad generativa",
    type: "commission",
    price: 1800,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1761078739072-a10f63f3e478?w=1200&q=80",
    available: true,
    description: "Diseño de identidad visual basada en tus datos. Incluye 3 iteraciones, animación 10s y código fuente.",
    edition: "Comisión abierta · 2 cupos /mes",
    turnaround: "2-3 semanas",
    sold: 14,
  },
  {
    id: "pr5",
    artist: findArtist("lola-serrano"),
    title: "EP digital · Lunar",
    type: "print",
    price: 12,
    currency: "EUR",
    image: "https://images.pexels.com/photos/13230484/pexels-photo-13230484.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    available: true,
    description: "7 piezas · FLAC + WAV + artwork digital",
    edition: "Ilimitado",
    sold: 842,
  },
  {
    id: "pr6",
    artist: findArtist("yuki-nakamura"),
    title: "Kioto 35mm · serie de 4",
    type: "print",
    price: 180,
    currency: "EUR",
    image: "https://images.unsplash.com/photo-1504198266287-1659872e6590?w=1200&q=80",
    available: true,
    description: "Set de 4 prints archivales 30×40 cm · firmados",
    edition: "Edición de 25",
    sold: 9,
  },
  {
    id: "pr7",
    artist: findArtist("theo-volkov"),
    title: "Fragua · escultura en bronce",
    type: "original",
    price: 7800,
    currency: "EUR",
    image: "https://images.unsplash.com/photo-1528895709218-bed5456e2c42?w=1200&q=80",
    available: true,
    description: "Bronce patinado · 62×28×22 cm · 14 kg",
    edition: "1 / 1",
    sold: 0,
  },
  {
    id: "pr8",
    artist: findArtist("sol-cabrera"),
    title: "Tazón · barro negro",
    type: "print",
    price: 48,
    currency: "EUR",
    image: "https://images.unsplash.com/photo-1528895709218-bed5456e2c42?w=1200&q=80",
    available: true,
    description: "Cerámica torneada a mano · 12×15 cm",
    edition: "Pieza única, serie abierta",
    sold: 62,
  },
  {
    id: "pr9",
    artist: findArtist("alain-mora"),
    title: "Commission · coreografía a medida",
    type: "commission",
    price: 3500,
    currency: "USD",
    image: "https://images.pexels.com/photos/24408960/pexels-photo-24408960.jpeg",
    available: true,
    description: "Coreografía original 3-7 min para tu evento. Incluye dirección y video registro.",
    edition: "1 cupo /mes",
    turnaround: "4-6 semanas",
    sold: 6,
  },
  {
    id: "pr10",
    artist: findArtist("tomas-herrera"),
    title: "Poema por encargo",
    type: "commission",
    price: 280,
    currency: "USD",
    image: "https://images.unsplash.com/photo-1512820790803-83ca734da794?w=1200&q=80",
    available: true,
    description: "Poema original sobre tu historia. PDF impresión y manuscrito firmado.",
    edition: "Cupo abierto",
    turnaround: "10 días",
    sold: 41,
  },
];

export const tiersByArtist = {
  "mar-quintero": [
    {
      id: "t1",
      name: "Observador",
      price: 4,
      perks: [
        "Acceso al feed privado",
        "Newsletter mensual del estudio",
        "Timelapses exclusivos",
      ],
    },
    {
      id: "t2",
      name: "Coleccionista",
      price: 12,
      featured: true,
      perks: [
        "Todo lo anterior",
        "1 print digital /mes",
        "Acceso a la sala de crítica",
        "Preventa 48h antes",
      ],
    },
    {
      id: "t3",
      name: "Mecenas",
      price: 48,
      perks: [
        "Todo lo anterior",
        "Estudio visit virtual 1-a-1 /trimestre",
        "Nombre en créditos de exposición",
        "Obra pequeña anual",
      ],
    },
  ],
};

export const revenueStats = {
  currency: "EUR",
  mtd: 2840,
  mtdPrev: 2210,
  lifetime: 38210,
  payoutNext: 1420,
  payoutOn: "15 feb",
  sales: [
    { day: "LU", amount: 340 },
    { day: "MA", amount: 180 },
    { day: "MI", amount: 520 },
    { day: "JU", amount: 280 },
    { day: "VI", amount: 640 },
    { day: "SÁ", amount: 380 },
    { day: "DO", amount: 500 },
  ],
  breakdown: [
    { label: "PRINTS", amount: 1240, pct: 43, color: "#FF3E00" },
    { label: "ORIGINALES", amount: 800, pct: 28, color: "#00FF66" },
    { label: "COMISIONES", amount: 560, pct: 19, color: "#0033FF" },
    { label: "SUSCRIPCIONES", amount: 240, pct: 8, color: "#FF0033" },
  ],
  subscribers: {
    total: 184,
    trend: +12,
    mrr: 980,
  },
  topProducts: ["pr2", "pr1", "pr3"],
  recentOrders: [
    { id: "o1", buyer: "Carla V.", item: "Respirar el ocre · Print A3", amount: 65, status: "pagado", time: "hace 12m" },
    { id: "o2", buyer: "Jon M.", item: "Suscripción Coleccionista", amount: 12, status: "recurrente", time: "hace 1h" },
    { id: "o3", buyer: "Studio Nord", item: "Commission · coreografía", amount: 3500, status: "en producción", time: "hace 4h" },
    { id: "o4", buyer: "Elena R.", item: "Kioto 35mm · serie de 4", amount: 180, status: "pagado", time: "hace 6h" },
    { id: "o5", buyer: "Hugo P.", item: "Poema por encargo", amount: 280, status: "esperando brief", time: "1d" },
  ],
};

export function getProduct(id) {
  return products.find((p) => p.id === id) || products[0];
}

export function getTiers(slug) {
  return tiersByArtist[slug] || tiersByArtist["mar-quintero"];
}

// CALLS · Becas, residencias, premios, convocatorias
export const calls = [
  {
    id: "c1",
    title: "Residencia Matadero Madrid 2026",
    org: "Matadero Madrid",
    type: "RESIDENCIA",
    discipline: "ARTES VISUALES",
    location: "Madrid · ES",
    remote: false,
    prize: "€ 8,000 + estudio 3 meses",
    prizeValue: 8000,
    deadline: "2026-03-15",
    daysLeft: 12,
    featured: true,
    verified: true,
    applicants: 284,
    cover: "https://images.unsplash.com/photo-1764345933694-7d4eb49ef266?w=1400&q=80",
    summary:
      "Residencia artística para proyectos que dialoguen con la arquitectura industrial del centro. Dirigido a artistas visuales con trayectoria inicial-media.",
    requirements: [
      "Portafolio con mínimo 5 piezas",
      "Carta de motivación (máx 500 palabras)",
      "Propuesta de proyecto específico para Matadero",
      "CV artístico",
    ],
    jury: ["Manuel Borja-Villel", "Soledad Gutiérrez", "Juan Canela"],
  },
  {
    id: "c2",
    title: "Prince Claus Fund · Seed Awards 2026",
    org: "Prince Claus Fund",
    type: "BECA",
    discipline: "MIXTO",
    location: "Internacional · Remote",
    remote: true,
    prize: "€ 5,000 · sin contraprestación",
    prizeValue: 5000,
    deadline: "2026-04-02",
    daysLeft: 30,
    featured: true,
    verified: true,
    applicants: 1204,
    cover: "https://images.unsplash.com/photo-1776235522022-68ff83b0b9e0?w=1400&q=80",
    summary:
      "Beca sin contraprestación para artistas emergentes del Sur Global cuyo trabajo dialogue con la cultura, la justicia social o el medio ambiente.",
    requirements: [
      "Ser artista del Sur Global",
      "Menos de 10 años de trayectoria profesional",
      "Propuesta de uso de la beca (máx 3 páginas)",
      "Dos cartas de recomendación",
    ],
    jury: ["Comité internacional PCF"],
  },
  {
    id: "c3",
    title: "Premio Velázquez · Pintura Joven",
    org: "Ministerio de Cultura ES",
    type: "PREMIO",
    discipline: "ARTES VISUALES",
    location: "España",
    remote: false,
    prize: "€ 15,000 + exposición",
    prizeValue: 15000,
    deadline: "2026-02-28",
    daysLeft: 3,
    featured: false,
    verified: true,
    urgent: true,
    applicants: 612,
    cover: "https://images.pexels.com/photos/1774301/pexels-photo-1774301.jpeg",
    summary:
      "Premio bienal para pintores menores de 40 años residentes en España. Incluye exposición individual en el Museo Reina Sofía.",
    requirements: [
      "Residencia legal en España",
      "Menor de 40 años al cierre de convocatoria",
      "Obra inédita específica",
      "Declaración artística",
    ],
    jury: ["Miquel Barceló", "Elena Asins", "Pedro Azara"],
  },
  {
    id: "c4",
    title: "Open Call · Sónar+D 2026",
    org: "Sónar Festival",
    type: "OPEN CALL",
    discipline: "MÚSICA",
    location: "Barcelona · ES",
    remote: false,
    prize: "Showcase + cachet €2,500",
    prizeValue: 2500,
    deadline: "2026-03-20",
    daysLeft: 17,
    featured: false,
    verified: true,
    applicants: 890,
    cover: "https://images.unsplash.com/photo-1765278797923-10a027f5c69d?w=1400&q=80",
    summary:
      "Convocatoria para artistas que integren música electrónica con tecnología creativa. Selección de 30 proyectos para el escenario Showcase.",
    requirements: [
      "Track o live set de 15 min",
      "Bio artística y rider técnico",
      "Al menos un release oficial en los últimos 2 años",
    ],
    jury: ["Equipo curaduría Sónar"],
  },
  {
    id: "c5",
    title: "Residencia FONCA · México",
    org: "Fondo Nacional para la Cultura y las Artes",
    type: "RESIDENCIA",
    discipline: "MIXTO",
    location: "CDMX · MX",
    remote: false,
    prize: "MXN $120,000 + 6 meses",
    prizeValue: 6000,
    deadline: "2026-04-10",
    daysLeft: 38,
    featured: false,
    verified: true,
    applicants: 428,
    cover: "https://images.unsplash.com/photo-1528895709218-bed5456e2c42?w=1400&q=80",
    summary:
      "Programa de residencias artísticas del Estado mexicano. Abierto a todas las disciplinas con énfasis en proyectos colaborativos con comunidades locales.",
    requirements: [
      "Nacionalidad mexicana o residencia permanente",
      "Proyecto colaborativo con comunidad",
      "Carta compromiso de permanencia",
    ],
    jury: ["Comité FONCA"],
  },
  {
    id: "c6",
    title: "Convocatoria comunitaria · Jam Fest",
    org: "ELARTE/NET Comunidad",
    type: "OPEN CALL",
    discipline: "MÚSICA",
    location: "Online · Global",
    remote: true,
    prize: "Featured + €500 en tips",
    prizeValue: 500,
    deadline: "2026-03-08",
    daysLeft: 5,
    featured: false,
    verified: false,
    community: true,
    applicants: 67,
    cover: "https://images.unsplash.com/photo-1465821185615-20b3c2fbf41b?w=1400&q=80",
    summary:
      "Convocatoria creada por la comunidad: los 10 mejores tracks de los jams abiertos de este mes se recopilan en un álbum colaborativo, featured en homepage.",
    requirements: [
      "Haber participado en al menos un jam del mes",
      "Track original (no covers)",
      "Duración 2-6 minutos",
    ],
    jury: ["Votación de la comunidad + curaduría editorial"],
  },
  {
    id: "c7",
    title: "Poesía Iberoamericana · XXII",
    org: "Casa de América",
    type: "PREMIO",
    discipline: "LITERARIAS",
    location: "España",
    remote: true,
    prize: "€ 12,000 + publicación",
    prizeValue: 12000,
    deadline: "2026-05-15",
    daysLeft: 73,
    featured: false,
    verified: true,
    applicants: 342,
    cover: "https://images.unsplash.com/photo-1512820790803-83ca734da794?w=1400&q=80",
    summary:
      "Premio anual de poesía inédita en lengua castellana. Dirigido a poetas iberoamericanos de cualquier edad. Obra original no publicada.",
    requirements: [
      "Poemario inédito 400-800 versos",
      "Lengua castellana",
      "Seudónimo + plica",
    ],
    jury: ["Luis García Montero", "Piedad Bonnett", "Carlos Marzal"],
  },
  {
    id: "c8",
    title: "Commission · Museo Picasso Málaga",
    org: "Museo Picasso Málaga",
    type: "COMISIÓN",
    discipline: "ARTES VISUALES",
    location: "Málaga · ES",
    remote: false,
    prize: "€ 22,000 · pieza sitio-específico",
    prizeValue: 22000,
    deadline: "2026-03-31",
    daysLeft: 28,
    featured: false,
    verified: true,
    applicants: 94,
    cover: "https://images.unsplash.com/photo-1504198266287-1659872e6590?w=1400&q=80",
    summary:
      "Comisión para obra de gran formato en el patio principal del museo. Diálogo con la colección permanente. Instalación durante verano 2026.",
    requirements: [
      "Trayectoria mínima de 10 años",
      "Portafolio con obras de gran formato",
      "Boceto inicial + presupuesto de producción",
    ],
    jury: ["Dirección artística Museo Picasso", "Comité externo"],
  },
];

export function getCall(id) {
  return calls.find((c) => c.id === id) || calls[0];
}

// MUSIC TRACKS · para perfiles musicales
export const tracksByArtist = {
  "lola-serrano": {
    type: "EP",
    title: "Lunar",
    year: 2026,
    cover: "https://images.unsplash.com/photo-1465821185615-20b3c2fbf41b?w=1200&q=80",
    tracks: [
      {
        id: "t-lola-1",
        title: "Lunar — overtura",
        duration: "2:48",
        plays: 184291,
        explicit: false,
        bpm: 72,
        key: "Am",
      },
      {
        id: "t-lola-2",
        title: "Canto para nadie",
        duration: "4:12",
        plays: 421088,
        explicit: false,
        bpm: 96,
        key: "Cm",
        featured: true,
      },
      {
        id: "t-lola-3",
        title: "Bolero eléctrico",
        duration: "3:36",
        plays: 98421,
        explicit: false,
        bpm: 108,
        key: "F#m",
      },
      {
        id: "t-lola-4",
        title: "Pez de luz (ft. Kenji Ríos)",
        duration: "5:02",
        plays: 62810,
        explicit: false,
        bpm: 84,
        key: "Gm",
      },
      {
        id: "t-lola-5",
        title: "Madrugada en ES",
        duration: "3:58",
        plays: 41902,
        explicit: true,
        bpm: 120,
        key: "Dm",
      },
      {
        id: "t-lola-6",
        title: "Matemática del amor",
        duration: "4:44",
        plays: 28140,
        explicit: false,
        bpm: 88,
        key: "Em",
      },
      {
        id: "t-lola-7",
        title: "Volver al mar",
        duration: "6:21",
        plays: 19842,
        explicit: false,
        bpm: 68,
        key: "Am",
      },
    ],
  },
  "andres-pinto": {
    type: "ÁLBUM",
    title: "Variaciones sobre el silencio",
    year: 2025,
    cover: "https://images.unsplash.com/photo-1465821185615-20b3c2fbf41b?w=1200&q=80",
    tracks: [
      {
        id: "t-andres-1",
        title: "Bach · Suite No. 1 en Sol",
        duration: "18:42",
        plays: 42108,
        bpm: 60,
        key: "G",
      },
      {
        id: "t-andres-2",
        title: "Improvisación libre 01",
        duration: "7:14",
        plays: 12420,
        bpm: 52,
        key: "Dm",
      },
      {
        id: "t-andres-3",
        title: "Andantino en La menor",
        duration: "4:28",
        plays: 28941,
        bpm: 76,
        key: "Am",
        featured: true,
      },
      {
        id: "t-andres-4",
        title: "Silencio, después",
        duration: "12:04",
        plays: 8120,
        bpm: 40,
        key: "Cm",
      },
    ],
  },
};

export function getTracks(slug) {
  if (!slug) return null;
  // Normalize between hyphen- and underscore-based handles so a backend user
  // @lola_serrano still finds the mock tracks keyed as "lola-serrano".
  return (
    tracksByArtist[slug] ||
    tracksByArtist[slug.replace(/_/g, "-")] ||
    tracksByArtist[slug.replace(/-/g, "_")] ||
    null
  );
}

// APPLICATIONS · Portfolio de postulaciones por artista
export const applicationsByArtist = {
  "mar-quintero": [
    {
      callId: "c1",
      appliedAt: "2026-02-12",
      status: "shortlisted",
      note: "Seleccionada entre 24 finalistas",
    },
    {
      callId: "c3",
      appliedAt: "2026-02-08",
      status: "applied",
    },
    {
      callId: "c8",
      appliedAt: "2025-11-22",
      status: "won",
      note: "Ganadora · exposición en verano 2026",
    },
    {
      callId: "c2",
      appliedAt: "2025-09-10",
      status: "rejected",
    },
  ],
  "kenji-rios": [
    {
      callId: "c4",
      appliedAt: "2026-02-18",
      status: "shortlisted",
    },
    {
      callId: "c2",
      appliedAt: "2026-01-05",
      status: "won",
      note: "€5,000 · sin contraprestación",
    },
  ],
  "lola-serrano": [
    {
      callId: "c4",
      appliedAt: "2026-02-20",
      status: "applied",
    },
    {
      callId: "c6",
      appliedAt: "2026-02-15",
      status: "shortlisted",
    },
  ],
};

export const credentialsByArtist = {
  "mar-quintero": [
    { year: "2026", label: "Comisión · Museo Picasso Málaga", verified: true },
    { year: "2025", label: "Beca creación · Ayuntamiento de Madrid", verified: true },
    { year: "2024", label: "Seleccionada · ARCOmadrid · Solo Projects", verified: true },
    { year: "2024", label: "Residencia · La Térmica · Málaga", verified: true },
    { year: "2022", label: "MA · Bellas Artes · UCM", verified: true },
  ],
  "kenji-rios": [
    { year: "2026", label: "Prince Claus Fund · Seed Award", verified: true },
    { year: "2025", label: "Ars Electronica · Honorary Mention", verified: true },
    { year: "2024", label: "Showcase · Sónar+D", verified: true },
  ],
  "lola-serrano": [
    { year: "2025", label: "Nominación · Premios MIN · Mejor voz", verified: true },
    { year: "2024", label: "Showcase · Primavera Sound", verified: true },
    { year: "2023", label: "Gira · 14 ciudades · España + MX", verified: true },
  ],
};

export function getApplications(slug) {
  return applicationsByArtist[slug] || [];
}

export function getCredentials(slug) {
  return credentialsByArtist[slug] || [];
}

// COLLABORATIONS — cross-artist network
export const collaborations = [
  {
    id: "cl1",
    from: "lola-serrano",
    to: "kenji-rios",
    type: "feat",
    year: 2026,
    label: "Pez de luz (ft.)",
    works: 1,
  },
  {
    id: "cl2",
    from: "mar-quintero",
    to: "kenji-rios",
    type: "visual-music",
    year: 2025,
    label: "Video art · Serie Ocre",
    works: 2,
  },
  {
    id: "cl3",
    from: "alain-mora",
    to: "lola-serrano",
    type: "performance-music",
    year: 2025,
    label: "Cuerpo archivo · live",
    works: 1,
  },
  {
    id: "cl4",
    from: "yuki-nakamura",
    to: "mar-quintero",
    type: "visual-visual",
    year: 2024,
    label: "Expo dual · Tokyo-Madrid",
    works: 3,
  },
  {
    id: "cl5",
    from: "ines-valverde",
    to: "kenji-rios",
    type: "code-code",
    year: 2025,
    label: "Terra Sintética · NFT",
    works: 4,
  },
  {
    id: "cl6",
    from: "tomas-herrera",
    to: "lola-serrano",
    type: "text-music",
    year: 2024,
    label: "Letras · EP Lunar",
    works: 2,
  },
  {
    id: "cl7",
    from: "andres-pinto",
    to: "alain-mora",
    type: "performance-music",
    year: 2025,
    label: "Bach para danza",
    works: 1,
  },
  {
    id: "cl8",
    from: "sol-cabrera",
    to: "theo-volkov",
    type: "sculpture",
    year: 2024,
    label: "Residencia Oaxaca",
    works: 2,
  },
  {
    id: "cl9",
    from: "theo-volkov",
    to: "mar-quintero",
    type: "visual-visual",
    year: 2023,
    label: "Instalación colectiva",
    works: 1,
  },
  {
    id: "cl10",
    from: "ines-valverde",
    to: "alain-mora",
    type: "visual-dance",
    year: 2026,
    label: "Mapping en vivo",
    works: 1,
  },
  {
    id: "cl11",
    from: "yuki-nakamura",
    to: "tomas-herrera",
    type: "photo-poetry",
    year: 2025,
    label: "Fotolibro · Volver",
    works: 1,
  },
  {
    id: "cl12",
    from: "sol-cabrera",
    to: "lola-serrano",
    type: "craft-music",
    year: 2026,
    label: "Objetos para videoclip",
    works: 1,
  },
  {
    id: "cl13",
    from: "andres-pinto",
    to: "mar-quintero",
    type: "music-visual",
    year: 2024,
    label: "Score para expo",
    works: 1,
  },
];

export const collabTypeLabels = {
  feat: "FEATURING MUSICAL",
  duet: "DÚO",
  "visual-music": "VIDEO ARTE + MÚSICA",
  "performance-music": "MÚSICA EN ESCENA",
  "visual-visual": "EXPO COMPARTIDA",
  "code-code": "COLAB DIGITAL",
  "text-music": "LETRAS",
  "sculpture": "ESCULTURA",
  "visual-dance": "VISUAL + DANZA",
  "photo-poetry": "FOTO + POESÍA",
  "craft-music": "OBJETOS + VIDEO",
  "music-visual": "SCORE VISUAL",
};

export const collabTypeColor = {
  feat: "#FF3E00",
  duet: "#FF3E00",
  "visual-music": "#00FF66",
  "performance-music": "#FFD600",
  "visual-visual": "#0033FF",
  "code-code": "#FF0033",
  "text-music": "#A78BFA",
  "sculpture": "#A1A1AA",
  "visual-dance": "#00FF66",
  "photo-poetry": "#A78BFA",
  "craft-music": "#FFD600",
  "music-visual": "#FF3E00",
};

// NEWSLETTER · Boletín semanal auto-generado
export const currentIssue = {
  number: 14,
  date: "FEB · SEM 04 · 2026",
  week: "24-28 FEB",
  subscribers: 8421,
  openRate: 68,
  sections: {
    featured: {
      kind: "COLAB",
      title: "Lola Serrano × Kenji Ríos estrenan «Pez de luz»",
      cover:
        "https://images.unsplash.com/photo-1765278797923-10a027f5c69d?w=1600&q=80",
      body:
        "Tras dos semanas de colaboración asincrónica en la Sala de Jam 24/7, el single reúne la voz de Lola con una capa generativa codificada en p5.js. La pieza visual animada acompaña el release y ya acumula 62K plays en 48h.",
      artists: ["lola-serrano", "kenji-rios"],
      link: "/artista/lola-serrano",
    },
    wins: [
      {
        artist: "mar-quintero",
        call: "c8",
        amount: "€ 22,000",
        label: "Comisión Museo Picasso Málaga",
      },
      {
        artist: "kenji-rios",
        call: "c2",
        amount: "€ 5,000",
        label: "Prince Claus · Seed Award",
      },
    ],
    newCollabs: [
      { id: "cl10", label: "Mapping en vivo" },
      { id: "cl12", label: "Objetos para videoclip" },
    ],
    topLive: {
      id: "live1",
      title: "Estreno mundial · nuevo EP",
      artist: "lola-serrano",
      viewers: 14820,
      venue: "Razzmatazz BCN",
    },
    topPrints: [
      { id: "pr2", sold: 38 },
      { id: "pr8", sold: 62 },
      { id: "pr5", sold: 842 },
    ],
    trendingTracks: [
      { id: "t-lola-2", delta: "+212%" },
      { id: "t-lola-4", delta: "+148%" },
      { id: "t-andres-3", delta: "+94%" },
    ],
    debuts: [
      { artist: "sol-cabrera", reason: "Primera tienda abierta · barro negro" },
      { artist: "tomas-herrera", reason: "Lectura pública agendada · vie 19:00" },
    ],
    editorial:
      "Esta semana el ecosistema se movió en dos direcciones: más dinero saliendo de las instituciones hacia los artistas (€27K en premios entregados a miembros) y más líneas nuevas dibujándose en el mapa de colaboraciones. La música y el video siguen siendo los mayores puentes entre disciplinas.",
    number: {
      prizesWon: 27000,
      newCollabs: 2,
      liveViewers: 14820,
      newArtists: 14,
      tracksPublished: 19,
      worksSold: 184,
    },
  },
};

export const pastIssues = [
  { n: 13, date: "FEB · SEM 03", headline: "El regreso del bolero eléctrico" },
  { n: 12, date: "FEB · SEM 02", headline: "Residencias: qué cerró, qué abrió" },
  { n: 11, date: "FEB · SEM 01", headline: "Diez jams que hicieron ruido" },
  { n: 10, date: "ENE · SEM 04", headline: "Enero en cifras · balance del mes" },
  { n: 9, date: "ENE · SEM 03", headline: "Nuevos sellos independientes del directorio" },
];

// PRESS KIT · data auto-generada por artista
export const pressKitByArtist = {
  "mar-quintero": {
    longBio:
      "Mar Quintero (Madrid, 1990) construye pinturas como campos de respiración: capas de óleo sobre lino donde el color se vuelve pulso y el gesto arquitectura de lo íntimo. Su obra ha sido exhibida en ARCOmadrid, La Térmica (Málaga) y la Galería Helga de Alvear. Actualmente es artista residente en Matadero Madrid y prepara una comisión de gran formato para el Museo Picasso de Málaga. Trabaja con la memoria como material primario, explorando cómo el ocre, el rojo y el negro se articulan como vocabulario emocional propio de la pintura ibérica contemporánea.",
    shortBio:
      "Pintora contemporánea basada en Madrid. Explora la memoria como material pictórico.",
    press: [
      {
        quote:
          "Una de las voces más sólidas de la nueva pintura ibérica. Su paleta es terca, deliberada, y emocional.",
        source: "El País · Suplemento Cultural",
        date: "ENE 2026",
      },
      {
        quote:
          "Mar Quintero convierte el ocre en un idioma. Cada cuadro es una frase que se termina de pronunciar en la retina del espectador.",
        source: "Revista Exit",
        date: "NOV 2025",
      },
      {
        quote:
          "No he visto a nadie de su generación trabajar el lino con tanta convicción.",
        source: "Manuel Borja-Villel",
        date: "CONVERSATORIO MNCARS",
      },
    ],
    featuredWorks: [
      { id: "w1", title: "Respirar el ocre · 04", medium: "Óleo sobre lino", size: "180×140 cm", year: 2025, image: "https://images.unsplash.com/photo-1764345933694-7d4eb49ef266?w=1400&q=80" },
      { id: "w2", title: "Memoria del rojo", medium: "Óleo sobre lino", size: "200×160 cm", year: 2025, image: "https://images.pexels.com/photos/1774301/pexels-photo-1774301.jpeg" },
      { id: "w3", title: "Campo I", medium: "Óleo y cera sobre lino", size: "120×100 cm", year: 2024, image: "https://images.unsplash.com/photo-1776235522022-68ff83b0b9e0?w=1400&q=80" },
      { id: "w4", title: "Negros de Oaxaca", medium: "Óleo sobre lino", size: "90×70 cm", year: 2024, image: "https://images.unsplash.com/photo-1528895709218-bed5456e2c42?w=1400&q=80" },
      { id: "w5", title: "Estudio azul", medium: "Óleo sobre lino", size: "140×120 cm", year: 2023, image: "https://images.pexels.com/photos/3977944/pexels-photo-3977944.jpeg" },
    ],
    audience: {
      followers: 12400,
      avgEngagement: 6.8,
      monthlyReach: 184000,
      demographics: [
        { label: "Madrid", pct: 38 },
        { label: "CDMX", pct: 22 },
        { label: "Barcelona", pct: 14 },
        { label: "Resto", pct: 26 },
      ],
    },
    representation: {
      gallery: "Galería Helga de Alvear",
      contact: "Elena Ruiz · elena@helgadealvear.com",
      phone: "+34 91 468 05 06",
    },
    downloads: [
      { label: "Portfolio · PDF", size: "28 MB" },
      { label: "Bio + CV · PDF", size: "340 KB" },
      { label: "Fotos prensa · ZIP", size: "84 MB" },
      { label: "Alta resolución · 5 obras", size: "210 MB" },
    ],
  },
  "lola-serrano": {
    longBio:
      "Lola Serrano (Sevilla, 1992) es una cantautora cuyo trabajo vive entre el bolero y la música electrónica contemporánea. Su voz, modelada desde adolescente en tablaos flamencos, ha sido recontextualizada en producciones que dialogan con Arca, Rosalía y el trip-hop de los 90. Ha llenado Razzmatazz en Barcelona, ha sido showcase en Primavera Sound y se presenta en Sónar+D 2026. Su próximo EP «Lunar» se publica en marzo.",
    shortBio:
      "Cantautora · bolero electrónico. Basada en Barcelona.",
    press: [
      {
        quote: "Una voz como si Mercedes Sosa se encontrara con Aphex Twin.",
        source: "Pitchfork ES",
        date: "FEB 2026",
      },
      {
        quote: "Lola Serrano está reescribiendo el bolero para la generación streaming.",
        source: "Rockdelux",
        date: "DIC 2025",
      },
    ],
    featuredWorks: [
      { id: "m1", title: "Canto para nadie · single", medium: "Audio · single", size: "4:12", year: 2026, image: "https://images.unsplash.com/photo-1465821185615-20b3c2fbf41b?w=1400&q=80" },
      { id: "m2", title: "EP Lunar · artwork", medium: "Digital artwork", size: "3000×3000", year: 2026, image: "https://images.unsplash.com/photo-1765278797923-10a027f5c69d?w=1400&q=80" },
      { id: "m3", title: "Razzmatazz · live session", medium: "Video · 1h 12min", size: "4K", year: 2025, image: "https://images.pexels.com/photos/13230484/pexels-photo-13230484.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
    ],
    audience: {
      followers: 45200,
      avgEngagement: 9.2,
      monthlyReach: 720000,
      demographics: [
        { label: "Barcelona", pct: 24 },
        { label: "Madrid", pct: 20 },
        { label: "CDMX", pct: 18 },
        { label: "Resto", pct: 38 },
      ],
    },
    representation: {
      gallery: "Booking · La Máquina Agency",
      contact: "Bruno Castro · bruno@lamaquina.agency",
      phone: "+34 654 321 099",
    },
    downloads: [
      { label: "Rider técnico · PDF", size: "1.2 MB" },
      { label: "Bio + press release · PDF", size: "480 KB" },
      { label: "Stems EP Lunar · ZIP", size: "1.4 GB" },
      { label: "Fotos prensa · ZIP", size: "96 MB" },
    ],
  },
};

export function getPressKit(slug) {
  return pressKitByArtist[slug] || pressKitByArtist["mar-quintero"];
}

export function getArtist(slug) {
  return findArtist(slug) || artists[0];
}

export function getPostsByArtist(slug) {
  return posts.filter((p) => p.artist && p.artist.slug === slug);
}
